import { render, staticRenderFns } from "./NewsTitle.vue?vue&type=template&id=71e17a52&lang=pug&"
import script from "./NewsTitle.vue?vue&type=script&lang=js&"
export * from "./NewsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports